import { apiClient } from '@/shared/api';
import type {
  StopWordCreate,
  StopWordCreateResponse,
  StopWordListParams,
  StopWordListResponse,
  StopWordResponse,
  StopWordUpdate,
} from './types';

// Re-export types for convenience
export type {
  PredicateInStopWordRequest,
  PredicateInStopWordResponse,
  StopWordCreate,
  StopWordCreateResponse,
  StopWordInList,
  StopWordListParams,
  StopWordListResponse,
  StopWordResponse,
  StopWordUpdate,
} from './types';

/**
 * GET /stop-word - list stop words per OpenAPI GET /stop-word
 */
export const fetchStopWords = async (params?: StopWordListParams): Promise<StopWordListResponse> => {
  const { data } = await apiClient.get<StopWordListResponse>('/stop-word', { params });
  return data;
};

/**
 * POST /stop-word - create stop word per OpenAPI POST /stop-word
 */
export const createStopWord = async (payload: StopWordCreate): Promise<StopWordCreateResponse> => {
  const { data } = await apiClient.post<StopWordCreateResponse>('/stop-word', payload);
  return data;
};

/**
 * PUT /stop-word/{id} - update stop word per OpenAPI PUT /stop-word/{id}
 */
export const updateStopWord = async ({
  id,
  payload,
}: {
  id: number;
  payload: StopWordUpdate;
}): Promise<StopWordResponse> => {
  const { data } = await apiClient.put<StopWordResponse>(`/stop-word/${id}`, payload);
  return data;
};

/**
 * DELETE /stop-word/{id} - soft delete stop word per OpenAPI DELETE /stop-word/{id}
 */
export const deleteStopWord = async (id: number): Promise<void> => {
  await apiClient.delete(`/stop-word/${id}`);
};
